module.exports = __webpack_public_path__ + "static/media/bg_downgrade_suggestion_from_45_to_49.9d74073a.webp";